import React,{ createContext , useState} from "react";
import { PRODUCTS } from "../../products";

export const ShopContext = createContext(null);

const getDefaultCart = () => {
    let cart = {};
    // Iterate over each category in the PRODUCTS object
    Object.values(PRODUCTS).forEach(category => {
      // Iterate over each product within the category
      category.forEach(product => {
        cart[product.id] = 0; // Initialize each product's quantity to 0
      });
    });
    return cart;
  };

export const findProductById = (id, products) => {
    for (let category in products) {
      const product = products[category].find(product => product.id === id);
      if (product) return product;
    }
    return null;
  };

export const ShopContextProvider = (props) => {
    const [cartItems,setCartItems] = useState(getDefaultCart());


    const getTotalAmount = () => {
        let totalAmount = 0;
        Object.keys(cartItems).forEach((itemId) => {
          const product = findProductById(parseInt(itemId), PRODUCTS);
          if (product) {
            totalAmount += cartItems[itemId] * product.price;
          }
        });
        return totalAmount;
      };

    const addToCart = (itemId) => {
        setCartItems((prev) => ({...prev, [itemId]: (prev[itemId] || 0) + 1}));
    }

    const removeFromCart = (itemId) => {
        setCartItems((prev) => ({...prev, [itemId]: Math.max(0, prev[itemId] - 1)}));
    }

    const contextValue = {
        cartItems,
        addToCart, 
        removeFromCart,
        getTotalAmount
    };

    console.log(cartItems);

    return<ShopContext.Provider value={contextValue}>{props.children}</ShopContext.Provider>;
}
